/**
 * Decode a JWT token to extract its payload
 * @param {string} token - JWT token string
 * @returns {object|null} - Decoded payload or null if invalid
 */
export const decodeJWT = (token) => {
  if (!token) return null

  try {
    // Split the token into parts
    const parts = token.split('.')
    if (parts.length !== 3) return null

    // Get the payload (second part)
    const payload = parts[1]

    // Convert base64url to base64
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')

    // Add padding if necessary
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')

    // Decode base64 to string
    const jsonString = atob(padded)

    // Parse JSON
    return JSON.parse(jsonString)
  } catch (error) {
    console.error('Error decoding JWT:', error)
    return null
  }
}

/**
 * Get user level from JWT token
 * @param {string} token - JWT token string
 * @returns {string} - User level ('admin', 'beta', 'guest', etc.)
 */
export const getUserLevelFromToken = (token) => {
  const decoded = decodeJWT(token)
  return decoded?.app_metadata?.user_level || 'guest'
}

/**
 * Check if user is admin
 * @param {string} token - JWT token string
 * @returns {boolean} - True if user is admin
 */
export const isAdmin = (token) => getUserLevelFromToken(token) === 'admin'

/**
 * Check if user is beta
 * @param {string} token - JWT token string
 * @returns {boolean} - True if user is beta
 */
export const isBeta = (token) => getUserLevelFromToken(token) === 'beta'
